// extracted by mini-css-extract-plugin
export default {"mapXS":"amap_mapXS__Xkxt2","mapS":"amap_mapS__B2aMM","mapM":"amap_mapM__Phb5u","mapL":"amap_mapL__jZEEo"};